import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Routes from './Router';
import { BrowserRouter } from 'react-router-dom';
import reducers from './component/common/redux/reducers';
import { Provider } from "react-redux";
import { createStore } from "redux";
import { ToastContainer, } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={createStore(reducers)}>
        <Routes />
      </Provider>
    </BrowserRouter>
    <ToastContainer
      position="top-right"
      autoClose={1500}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
    />
  </React.StrictMode>
);

